import { gettingStarted } from './privateCloudBusinessEditionFactoryConfigVME';
export const pagesConfig = [...gettingStarted()];
